export default __webpack_public_path__ + "static/media/icon-software-projects.60ad138f.svg";